<template>
  <div>
    <div class="card">
      <div class="loader-container" v-if="!ready.dienstleister">
        <Loader />
        <div class="loader-message">
          Lade Dienstleister
        </div>
      </div>
      <transition :name="animations.fadeIn.name" :enter-active-class="animations.fadeIn.enter" :leave-active-class="animations.fadeIn.leave">
        <div class="card-body" v-if="ready.dienstleister">
          <div class="headline">
            <h5>Dienstleister</h5>
          </div>
          <div class="table-responsive datatable-vue table-scroll" v-if="sort_rdy">
            <b-table show-empty :items="tableitems.cron_dienstleister" :fields="tablefields.cron_dienstleister">
              <template v-slot:cell(link)="row">
                <feather type="edit-2" class="infra-blue pointer" @click="$router.push('/admin/dashboard/dienstleister/' + row.item.id)"></feather>
              </template>
              <template slot="empty">
                <div class="text-center">
                  Keine Dienstleister gefunden.
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/LoaderRelative.vue";

export default {
  name: "WidgetAdminDienstleister",
  components: {
    Loader,
  },
  data() {
    return {
      sort_rdy: false,
      tablefields: {
        cron_dienstleister: [
          { key: "name", label: "Firma", sortable: false },
          { key: "link", label: "Optionen", sortable: false },
        ],
      },
      tableitems: {
        cron_dienstleister: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      dienstleister: "app/dienstleister",
      ready: "app/readyState",
      animations: "app/animations",
    }),
  },
  created: async function() {
    if (this.dienstleister == false) {
      try {
        await this.$store.dispatch("app/apiGetDienstleister");
      } catch (error) {
        console.log(error);
      }
    }

    //assign and sort kunden to display, limit output
    const maxDienstleister = 3;
    this.tableitems.cron_dienstleister = this.cloneNonReactive(this.dienstleister).slice(0, maxDienstleister);

    this.tableitems.cron_dienstleister.sort(function(a, b) {
      let aDate = new Date(a.created_on);
      let bDate = new Date(b.created_on);
      return aDate - bDate;
    });
    this.sort_rdy = true;
  },
};
</script>

<style scoped></style>
